import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { formatText } from 'core/i18n';
import { useRecordPage } from 'components/sessionTimeOut/SessionExpiredModal/hooks/useRecordPage';
import { setPageName } from 'actions/errorViewNavigation';

const SessionExpiredModalComponent = ({
    showModal,
    modalClass,
    userProfile,
    productsDescription,
    onClickLoginAgain,
    onHide,
    onExit,
    setPageName,
}) => {
    useRecordPage({ showModal, userProfile, productsDescription, setPageName });

    return (
        <div>
            <Modal
                show={showModal}
                onHide={onHide}
                dialogClassName={modalClass}
                backdrop="static"
                keyboard={false}
                animation={false}
            >
                <Modal.Body>
                    <h5 className="font-heading5">{formatText('session-sessionExpiredTitle')}</h5>
                    <div className="icon-container expired-Message">
                        <i className="icons icons--icon-clock"></i>
                        <p className="font-paragraph2">{formatText('session-sessionExpiredMessage')}</p>
                    </div>
                    <div className="form__buttons">
                        <button className="form__button form__button-clean" onClick={onExit}>
                            {formatText('button-exit')}
                        </button>
                        <button className="form__button form__button-secondary" onClick={onClickLoginAgain}>
                            {formatText('button-loginAgain')}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export const SessionExpiredModal = connect(null, dispatch => ({
    setPageName: bindActionCreators(setPageName, dispatch),
}))(SessionExpiredModalComponent);
